export const BUSINESS = {
  name: "LAD CO Electrical",
  owner: "Luke Dyson",
  phone: "0407 202 965",
  phoneHref: "tel:+61407202965",
  email: "admin@ladcoelectrical.com.au",
  emailHref: "mailto:admin@ladcoelectrical.com.au",
  region: "Northern Rivers, NSW",
  tagline: "Fast. Friendly. Experienced.",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Contact", to: "/contact" },
];

export const IMAGES = {
  hero: "/images/ladco-a.jpg",
  about: "/images/ladco-d.jpg",
  truck: "/images/ladco-a.jpg",  battery: "/images/ladco-f.jpg",
  inverter: "/images/ladco-e.jpg",
  switchboard: "/images/ladco-g.jpg",
  cabling: "/images/ladco-h.jpg",
  buildSite: "/images/ladco-i.jpg",
  ute: "/images/ladco-k.jpg",
  tempSupply: "/images/ladco-j.jpg",
  climb: "/images/ladco-l.jpg",
  climbWide: "/images/ladco-m.jpg",
};

export const TRUST_ITEMS = [
  {
    title: "20+ Years Experience",
    text: "Decades of electrical industry experience.",
  },
  {
    title: "Level 2 Accredited",
    text: "Level 2 accredited service provider.",
  },
  {
    title: "Local Family Business",
    text: "A local business serving the Northern Rivers community.",
  },
  {
    title: "Fast & Friendly Service",
    text: "Professional electrical service with a friendly approach.",
  },
];

export const SERVICES = [
  {
    id: "residential",
    name: "Residential Electrical",
    text: "Electrical services for homes and residential properties across the Northern Rivers.",
  },
  {
    id: "commercial",
    name: "Commercial Electrical",
    text: "Electrical services for commercial businesses and properties.",
  },
  {
    id: "level2",
    name: "Level 2 Electrical Services",
    text: "LAD CO Electrical is a Level 2 accredited service provider operating across the Northern Rivers region of NSW.",
  },
];

export const SERVICE_DETAILS = {
  residential: {
    title: "Residential Electrical Services",
    intro:
      "From everyday repairs to complete electrical work for renovations and new homes, LAD CO Electrical helps homeowners across the Northern Rivers with safe, reliable electrical work and quality workmanship.",
    image: IMAGES.switchboard,
    imageAlt: "LAD CO Electrical electrician working on a home switchboard and metering enclosure",
    items: [
      { name: "General Electrical Repairs & Maintenance", text: "From faulty power points to flickering lights, we diagnose and repair everyday electrical problems quickly and safely, keeping your home's electrical system in reliable working order." },
      { name: "New Power Points & Switches", text: "Additional power points, switches and dimmers installed where you need them, with neat workmanship and minimal disruption to your home." },
      { name: "Lighting Installation & Upgrades", text: "Modern, energy-efficient lighting installed or upgraded throughout your home — from downlights and feature lighting to practical task lighting." },
      { name: "Ceiling Fans", text: "Ceiling fan installation and replacement, wired safely and securely for reliable year-round comfort." },
      { name: "Smoke Alarms", text: "Smoke alarm installation, replacement and checks to help keep your household safe and your home compliant with current requirements." },
      { name: "Switchboard Upgrades & Repairs", text: "Switchboard upgrades and repairs to safely handle modern electrical demand, including safety switch protection where required." },
      { name: "Safety Inspections", text: "Thorough electrical safety inspections that identify potential hazards before they become serious problems — ideal before buying, selling or renovating." },
      { name: "Fault Finding & Troubleshooting", text: "Systematic fault finding to track down the cause of tripping circuits, power losses and unexplained electrical issues." },
      { name: "Renovations & New Homes", text: "Complete electrical work for renovations, extensions and new homes, planned and installed to suit your build." },
      { name: "Outdoor & Security Lighting", text: "Outdoor, garden and security lighting to make your home safer, more welcoming and more practical after dark." },
      { name: "Electrical Upgrades & Replacements", text: "Replacing ageing wiring, fittings and equipment with modern, safer alternatives you can rely on." },
      { name: "Level 2 Services Where Required", text: "Where your job involves the connection to the electricity network, our Level 2 accreditation means we can help where applicable, subject to site requirements." },
    ],
  },
  commercial: {
    title: "Commercial Electrical Services",
    intro:
      "LAD CO Electrical works with commercial businesses and properties across the Northern Rivers, providing reliable electrical solutions while minimising disruption to your business.",
    image: IMAGES.buildSite,
    imageAlt: "LAD CO Electrical service vehicle at a commercial construction site in the Northern Rivers",
    items: [
      { name: "Electrical Installations", text: "Complete electrical installations for commercial premises, delivered safely and to a professional standard." },
      { name: "Lighting Installation & Upgrades", text: "Efficient, fit-for-purpose lighting for workplaces, retail spaces and commercial buildings, including energy-saving upgrades." },
      { name: "Emergency Lighting", text: "Emergency and exit lighting installation and maintenance to support your building's safety requirements." },
      { name: "Power & Data Points", text: "Power and data points installed where your team needs them, keeping workspaces practical and connected." },
      { name: "Switchboards", text: "Commercial switchboard work, from upgrades to replacements, sized for the demands of your business." },
      { name: "Electrical Maintenance", text: "Ongoing electrical maintenance to keep your business running smoothly and reduce the risk of unexpected downtime." },
      { name: "Fault Finding & Repairs", text: "Fast, methodical fault finding and repairs to get your business back to normal with minimal disruption." },
      { name: "Safety Inspections", text: "Electrical safety inspections for commercial properties, helping you manage risk and meet your obligations." },
      { name: "Shop & Office Fit-Outs", text: "Electrical work for shop and office fit-outs, coordinated with your builder or project timeline." },
      { name: "Electrical Repairs & Upgrades", text: "Repairs and upgrades to ageing electrical systems, improving safety, capacity and reliability." },
      { name: "Preventative Maintenance", text: "Scheduled preventative maintenance programs that catch small issues before they interrupt your business." },
      { name: "Level 2 Electrical Services", text: "As a Level 2 accredited service provider, we can assist with network-related electrical work where applicable, subject to site requirements." },
    ],
  },
  level2: {
    title: "Level 2 Electrical Services",
    intro:
      "In New South Wales, certain electrical work involving the connection between a property and the electricity network must be carried out by an Accredited Service Provider (ASP). LAD CO Electrical is a Level 2 accredited service provider operating across the Northern Rivers region of NSW, which means we can discuss and carry out this type of work where applicable and subject to site requirements.",
    image: IMAGES.about,
    imageAlt: "LAD CO Electrical team member preparing equipment at the service vehicle",
    items: [
      { name: "Overhead Service Work", text: "Work on overhead service lines between the electricity network and your property, where applicable and subject to site requirements." },
      { name: "Underground Service Work", text: "Underground service cabling between the electricity network and your property, where applicable." },
      { name: "Service Connections", text: "Connecting a property to the electricity network, subject to network and site requirements." },
      { name: "Disconnects & Reconnects", text: "Temporary disconnection and reconnection of supply for renovations, metering or switchboard work, where applicable." },
      { name: "Consumer Mains", text: "Installation, repair or upgrade of the consumer mains that carry supply from the network to your switchboard." },
      { name: "Switchboard Upgrades", text: "Switchboard upgrades associated with service and metering work, subject to site requirements." },
      { name: "Property-to-Network Connection Work", text: "Electrical work involving the connection between your property and the electricity network." },
    ],
    note: "The exact Level 2 services available for your job depend on network and site requirements — contact LAD CO Electrical to confirm what applies to your property.",
  },
};

export const WHY_CHOOSE = [
  {
    title: "20+ Years Experience",
    text: "Over two decades of electrical industry experience.",
  },
  {
    title: "Local & Family Owned",
    text: "A local family business serving the Northern Rivers.",
  },
  {
    title: "Fast & Friendly",
    text: "Professional service without losing the personal approach.",
  },
  {
    title: "Comprehensive Service",
    text: "Electrical solutions for residential, commercial and industrial customers.",
  },
  {
    title: "Affordable",
    text: "A focus on providing comprehensive electrical services at an affordable price.",
  },
  {
    title: "Level 2 Accredited",
    text: "A Level 2 accredited service provider operating across the Northern Rivers region of NSW.",
  },
];

export const FAQS = [
  {
    q: "What areas does LAD CO Electrical service?",
    a: "LAD CO Electrical services the Northern Rivers region of NSW.",
  },
  {
    q: "What type of customers do you work with?",
    a: "LAD CO Electrical provides services for residential, commercial and industrial customers.",
  },
  {
    q: "Is LAD CO Electrical Level 2 accredited?",
    a: "Yes. LAD CO Electrical is a Level 2 accredited service provider.",
  },
  {
    q: "How much does electrical work cost?",
    a: "Pricing depends on the type and scope of work. Contact LAD CO Electrical to discuss your requirements and request a quote.",
  },
  {
    q: "How do I request a quote?",
    a: "You can complete the online quote form on this website or contact LAD CO Electrical directly by phone or email.",
  },
  {
    q: "How experienced is LAD CO Electrical?",
    a: "The business has more than 20 years of experience in the electrical industry.",
  },
  {
    q: "Is LAD CO Electrical a local business?",
    a: "Yes. LAD CO Electrical is a local family business servicing the Northern Rivers region.",
  },
];

export const PROJECTS = [
  {
    id: "p1",
    category: "Level 2",
    title: "Level 2 Electrical Project",
    image: IMAGES.truck,
    alt: "LAD CO Electrical service vehicle on site at an overhead power job in the Northern Rivers",
    description:
      "Electrical work completed by the LAD CO Electrical team in the Northern Rivers region.",
  },
  {
    id: "p2",
    category: "Level 2",
    title: "Level 2 Electrical Project",
    image: IMAGES.buildSite,
    alt: "LAD CO Electrical service vehicle on site at a job in the Northern Rivers",
    description:
      "The LAD CO Electrical team on site with a fully equipped service vehicle.",
  },
  {
    id: "p3",
    category: "Level 2",
    title: "Level 2 Electrical Project",
    image: IMAGES.level2,
    alt: "LAD CO Electrical linesman on a ladder at the top of a power pole",
    description:
      "Detailed overhead electrical work delivered safely and professionally.",
  },
  {
    id: "p4",
    category: "Level 2",
    title: "Level 2 Electrical Project",
    image: IMAGES.about,
    alt: "LAD CO Electrical team member preparing equipment at the service vehicle",
    description:
      "The LAD CO Electrical team on site, equipped and ready for the job.",
  },
  {
    id: "p5",
    category: "Residential",
    title: "Residential Electrical Project",
    image: IMAGES.switchboard,
    alt: "LAD CO Electrical electrician working on a home switchboard and metering enclosure",
    description:
      "Switchboard and metering work completed for a residential customer in the Northern Rivers.",
  },
  {
    id: "p6",
    category: "Residential",
    title: "Residential Electrical Project",
    image: IMAGES.battery,
    alt: "LAD CO Electrical installing a home battery energy storage system",
    description:
      "Home energy equipment installed by the LAD CO Electrical team.",
  },
  {
    id: "p7",
    category: "Residential",
    title: "Residential Electrical Project",
    image: IMAGES.inverter,
    alt: "LAD CO Electrical electrician wall-mounting electrical equipment inside a home",
    description:
      "In-home electrical equipment installed neatly and professionally.",
  },
  {
    id: "p8",
    category: "Residential",
    title: "Residential Electrical Project",
    image: IMAGES.cabling,
    alt: "LAD CO Electrical running cabling during a residential renovation",
    description:
      "Cabling work carried out during a residential project in the Northern Rivers.",
  },
  {
    id: "p9",
    category: "Residential",
    title: "Residential Electrical Project",
    image: IMAGES.buildSite,
    alt: "LAD CO Electrical service vehicle at a new home construction site",
    description:
      "The LAD CO Electrical team on site at a new build in the Northern Rivers region.",
  },
];

export const MARQUEE_ITEMS = [
  "Level 2 Accredited Service Provider",
  "20+ Years Experience",
  "Residential — Commercial — Industrial",
  "Northern Rivers NSW",
  "Local Family Business",
  "Fast & Friendly Service",
];

export const SERVICE_SECTIONS = [
  {
    id: "residential",
    title: "Residential",
    image: IMAGES.switchboard,
    imageAlt: "LAD CO Electrical electrician working on a home switchboard and metering enclosure",
    intro: "Electrical services for homes across the Northern Rivers — from new builds and renovations to repairs, upgrades and smart home solutions.",
    points: [
      "24/7 Emergency Service",
      "New Builds",
      "Kitchens & Bathrooms",
      "Outdoor Spaces / Pools",
      "Smart Home Automation",
      "Energy Optimisation",
      "Upgrades & Repairs",
      "EV Car Charging",
      "Renovations",
      "Data & Communications",
      "Switchboard Upgrades",
      "Solar & Battery Solutions — we can put you in touch with a trusted specialist",
    ],
  },
  {
    id: "commercial",
    title: "Commercial",
    image: IMAGES.buildSite,
    imageAlt: "LAD CO Electrical service vehicle at a commercial construction site in the Northern Rivers",
    intro: "Reliable electrical solutions for commercial businesses and properties, delivered with minimal disruption to your operations.",
    points: [
      "Commercial Fit Outs",
      "Commercial Upgrades & Maintenance",
      "Industrial, Warehouse & Factory Spaces",
      "3-Phase Power Solutions",
      {
        name: "Large Scale Projects",
        desc: "Have a development that requires a comprehensive energy plan and experienced project management? We can help manage the electrical requirements from planning through to completion.",
      },
      "Comprehensive Energy Planning",
      "Project Management",
    ],
  },
  {
    id: "level2",
    title: "Level 2",
    image: IMAGES.about,
    imageAlt: "LAD CO Electrical team member preparing equipment at the service vehicle",
    intro: "LAD CO Electrical is a Level 2 Accredited Service Provider operating across the Northern Rivers region of NSW.",
    points: [
      "Overhead & Underground Services",
      "Disconnects & Reconnects",
      "Australian Standards Knowledge & Support",
      "Private Defects",
      "Cross Arm Replacements",
      "Metering",
    ],
  },
];
